/**
 * AgencyLimitModal - Premium dark + gold monthly limit modal
 */
import { ArrowRight, Lock } from "lucide-react";

export function AgencyLimitModal({ daysUntilReset, onUpgrade, onClose }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center" data-testid="agency-limit-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative z-10 max-w-[420px] w-full mx-4 rounded-2xl overflow-hidden"
        style={{
          background: "linear-gradient(165deg, #1c1917 0%, #292524 40%, #1c1917 100%)",
          boxShadow: "0 0 80px rgba(202,138,4,0.12), 0 25px 60px rgba(0,0,0,0.5)",
        }}
        data-testid="agency-limit-content"
      >
        {/* Gold accent bar */}
        <div className="h-1" style={{ background: "linear-gradient(90deg, #92400e, #d97706, #f59e0b, #d97706, #92400e)" }} />

        <div className="px-6 sm:px-8 pt-7 pb-6">
          {/* Header */}
          <div className="text-center mb-5">
            <p className="text-[10px] font-medium tracking-[0.25em] uppercase mb-2" style={{ color: "#a8956e" }}>
              Usage Limit
            </p>
            <h2
              className="text-lg sm:text-xl font-bold mb-2 tracking-tight"
              style={{ color: "#f5f0e8", fontFamily: "Inter, system-ui, sans-serif" }}
              data-testid="agency-limit-title"
            >
              Monthly Download Limit Reached
            </h2>
            <div className="mx-auto my-3 w-16 h-px" style={{ background: "linear-gradient(90deg, transparent, #b8973a, transparent)" }} />
            <p className="text-[13px] leading-relaxed" style={{ color: "#b0a594" }}>
              You've reached your current monthly usage limit for Studio Pass 2.0.
            </p>
            <p className="text-[13px] leading-relaxed mt-2" style={{ color: "#b0a594" }}>
              Your access will refresh in{" "}
              <span className="font-semibold" style={{ color: "#f5f0e8" }}>
                {daysUntilReset} day{daysUntilReset !== 1 ? "s" : ""}
              </span>.
              <br />
              Need higher usage? Unlock extended access instantly.
            </p>
          </div>

          {/* Price card */}
          <div
            className="rounded-xl px-5 py-4 mb-5 text-center"
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(184,151,58,0.25)",
            }}
          >
            <p className="text-[11px] font-medium tracking-wide uppercase mb-1" style={{ color: "#a8956e" }}>
              Agency Plan
            </p>
            <p
              className="text-3xl font-extrabold my-1"
              style={{ color: "#f5f0e8", fontFamily: "Inter, system-ui, sans-serif" }}
              data-testid="agency-price"
            >
              &#8377;7,999
            </p>
            <p className="text-[11px] mt-1" style={{ color: "#b0a594" }}>
              Built for high-volume menus & multi-outlet usage
            </p>
          </div>

          {/* CTA Button */}
          <button
            data-testid="agency-upgrade-btn"
            onClick={onUpgrade}
            className="w-full h-13 flex items-center justify-center gap-2 rounded-xl text-sm font-bold tracking-wide transition-all duration-200"
            style={{
              background: "linear-gradient(135deg, #92400e 0%, #d97706 30%, #f59e0b 50%, #d97706 70%, #92400e 100%)",
              color: "#1c1917",
              boxShadow: "0 0 24px rgba(245,158,11,0.25), 0 4px 12px rgba(0,0,0,0.3)",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 0 36px rgba(245,158,11,0.4), 0 6px 16px rgba(0,0,0,0.3)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 0 24px rgba(245,158,11,0.25), 0 4px 12px rgba(0,0,0,0.3)"; }}
          >
            <Lock className="h-4 w-4" />
            Unlock Agency Plan
            <ArrowRight className="h-4 w-4" />
          </button>

          {/* Secondary close */}
          <button
            data-testid="agency-dismiss-btn"
            onClick={onClose}
            className="w-full text-center text-[12px] py-3 transition-colors"
            style={{ color: "#6b6356" }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "#a8956e"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "#6b6356"; }}
          >
            Okay, I'll wait
          </button>
        </div>
      </div>
    </div>
  );
}
